import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import GroupForm from 'modules/dashboard/components/GroupForm'
import groups from 'modules/dashboard/store/collections/communities/Groups'

interface Props {
  onClose: () => void
}

function NewGroup({ onClose }: Props) {
  const form = React.useRef(
    new Form(
      {
        title: null,
        description: null,
      },
      {
        title: 'string',
        description: 'string',
      }
    )
  ).current

  const submit = async (closePortal: ClosePortalFn) => {
    const { success } = await asyncAction(() => groups.create(form.data()))

    if (success) closePortal()
  }

  const disabled = !form.get('title').value || !form.get('description').value

  return (
    <Modal
      description={i18n.t('dashboard.groups.new.description')}
      illustration="people-add"
      onClose={onClose}
      onSubmit={submit}
      title={i18n.t('dashboard.groups.new.title')}
      footer={
        <Button disabled={disabled} submit>
          {i18n.t('dashboard.groups.new.title')}
        </Button>
      }
    >
      <GroupForm form={form} />
    </Modal>
  )
}

export default observer(NewGroup)
